import React from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { makeStyles, Theme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import BusinessRoundedIcon from '@material-ui/icons/BusinessRounded';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    background: theme.palette.background.paper,
    padding: theme.spacing(0.5),
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(2),
  },
  description: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  icon: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(3),
    fontSize: theme.spacing(8),
    color: theme.palette.text.primary,
  },
  text: {
    color: theme.palette.text.secondary,
    textTransform: 'capitalize',
  },
}));

interface IProps {
  classe?: string;
}

export default function PredefinedSoundCard(props: IProps) {
  const { classe } = props;
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Card
      id="predefined-sound-card"
      className={classe ? clsx(classe, classes.container) : classes.container}
    >
      <CardContent className={classes.content}>
        <BusinessRoundedIcon className={classes.icon} />
        <div className={classes.description}>
          <Typography className={classes.text} variant="h6">
            {t('message.sound.card.predefined')}
          </Typography>
          <Typography className={classes.text}>
            {t('message.sound.card.predefinedText')}
          </Typography>
        </div>
      </CardContent>
    </Card>
  );
}
